/**
 * Text helpers for "smart" client-side list filtering: accent-insensitive and
 * word-order independent, so typing "costa maria", "maria costa" or "maria
 * alberta" (without accents) all match "Maria Alberta Costa".
 */

/** Lowercase + strip diacritics (é→e, ã→a, ç→c…) so searches ignore accents. */
export function normalizeText(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/**
 * True when every whitespace-separated token of `query` appears somewhere in
 * `haystack` (both normalized). Order-independent and accent-insensitive.
 */
export function matchesQuery(haystack: string, query: string): boolean {
  const q = normalizeText(query);
  if (!q) return true;
  const hay = normalizeText(haystack);
  return q.split(/\s+/).every((token) => hay.includes(token));
}
